import { RestService } from './ResyService';
import { NewTarrif, Plant, PlantImagesTest, TarrifTypes } from '@/models';
import { PlantEndPoints } from './config';

export class PlantService extends RestService {

    addPlant(data: Plant, id?) {
        const addPlant = new FormData();
        addPlant.append("plant_name", data.plant_name);
        addPlant.append("plant_location", data.plant_location);
        addPlant.append("plant_date", data.plant_date);
        addPlant.append("plant_total_cost", data.plant_total_cost);
        addPlant.append("plant_location_type", data.plant_location_type);
        addPlant.append("plant_lat", data.plant_lat);
        addPlant.append("plant_lon", data.plant_lon);
        addPlant.append("plant_capacity", data.plant_capacity);
        addPlant.append("plant_total_panels", data.plant_total_panels);
        addPlant.append("plant_customer_id", data.plant_customer_id);
        addPlant.append("plant_terrif_rate", data.plant_terrif_rate);
        addPlant.append("tarrif_id", id);
        addPlant.append("billing_date", data.plant_billingdate);
        addPlant.append("poc", data.plant_poc);
        addPlant.append("reference_number", data.plant_reference_number);
        addPlant.append("plant_contact", data.plant_contact);
        data.plant_inverters.forEach((item: any, index: number) => {
            addPlant.append('plant_inverter' + index, item.id + ',' + item.description);
        });
        data.plant_images.forEach((item: any, index: number) => {
            addPlant.append('image' + index, item.img);
        });
        return this.post(PlantEndPoints.Plants, addPlant);
    }
    editPlant(data: Plant, id?) {
        const editPlant = new FormData();

        editPlant.append("plant_id", data.id);
        editPlant.append("plant_name", data.plant_name);
        editPlant.append("plant_location", data.plant_location);
        editPlant.append("plant_date", data.plant_date);
        editPlant.append("plant_total_cost", data.plant_total_cost);
        editPlant.append("plant_lat", data.plant_lat);
        editPlant.append("plant_lon", data.plant_lon);
        editPlant.append("plant_capacity", data.plant_capacity);
        editPlant.append("plant_total_panels", data.plant_total_panels);
        editPlant.append("plant_terrif_rate", data.plant_terrif_rate);
        editPlant.append("tarrif_id", id);
        editPlant.append("billing_date", data.plant_billingdate);
        editPlant.append("poc", data.plant_poc);
        editPlant.append("reference_number", data.plant_reference_number);
        editPlant.append("plant_contact", data.plant_contact);
        data.plant_images.forEach((item: any, index: number) => {
            editPlant.append('image' + index, item.img);
        });
        return this.post(PlantEndPoints.editPlants, editPlant);
    }
    postImages(event: PlantImagesTest) {
        const fd = new FormData();
        fd.append('plant_id', event.id);
        event.image_list.forEach((item: any, index: number) => {
            fd.append('image' + index, item.img);
        });
        return this.post(PlantEndPoints.PlantsImages, fd);
    }
    addTarrifCompany(data: NewTarrif) {
        let body = JSON.stringify({
            "tariff_company_name": data.tarrif_company_name,
        })
        return this.post(PlantEndPoints.newTarrifCompany, body);
    }
    updateMeteredStatus(plantID,status) {
        let body = JSON.stringify({
            "plant_id": plantID,
            "status":status
        })
        return this.post(PlantEndPoints.updatenetmeteredstatusplant, body);
    }
    addTarrifType(data: NewTarrif) {
        let body = JSON.stringify({
            "serialid": data.serialid,
            // "tariff_company_name": data.tarrif_company_name,
            "tariff_type_name": data.tarrif_type_name,
            "description": data.description,
        })
        return this.post(PlantEndPoints.newTarrifCompanyType, body);
    }

    getAllPlants() {
        return this.get(PlantEndPoints.AllPlants);
    }
    getDevice(id: number) {
        return this.get(PlantEndPoints.device + '?serial_id=' + id);
    }
    getAllPlantTypes() {
        return this.get(PlantEndPoints.PlantType);
    }
    getPLantById(id: number) {
        return this.get(PlantEndPoints.AllPlants + '/' + id);
    }
    getTerrifList() {
        return this.get(PlantEndPoints.TerrifList);
    }
    editTerrifList(data: TarrifTypes) {
        let body = JSON.stringify({
            "serialid": data.serialid,
            "zerotofifty": data.zerotofifty,
            "fiftytohnd": data.fiftytohnd,
            "hndtotwohnd": data.hndtotwohnd,
            "twohndtothreehnd": data.twohndtothreehnd,
            "threehndtosevenhnd": data.threehndtosevenhnd,
            "sevenhnd": data.sevenhnd
        })
        return this.post(PlantEndPoints.EditTariffData, body);
    }
}